import { type RelationshipListing, relationshipKeys } from '@taler/api-client'
import { useQuery } from '@tanstack/vue-query'
import { computed, type ComputedRef } from 'vue'
import { useApi } from '@/app/api'
import { retrying } from '@/app/retrying'

export interface UseConnections {
  readonly connections: ComputedRef<readonly RelationshipListing[]>
  readonly isLoading: ComputedRef<boolean>
  readonly error: ComputedRef<Error | null>
  readonly retrying: ComputedRef<boolean>
  retry(): void
}

export function useConnections(ledgerId: () => string | undefined): UseConnections {
  const api = useApi()
  const query = useQuery({
    queryKey: computed(() => relationshipKeys.list(ledgerId() ?? '')),
    queryFn: ({ signal }) => api.relationships.list(ledgerId() ?? '', signal),
    enabled: computed(() => ledgerId() !== undefined),
    retry: false,
  })

  return {
    connections: computed(() => query.data.value ?? []),
    isLoading: computed(() => query.isPending.value),
    error: computed(() => query.error.value),
    retrying: retrying(query),
    retry: () => {
      void query.refetch()
    },
  }
}
